/**
 * 使用量集計参照の Query Hook
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthHeader } from '@/hooks/useAuth';
import {
  getUsageAggregationAuthenticated,
  type UsageAggregationParams,
} from '@/lib/api/usage/usageAggregation';
import { usageAggregationKeys } from '../keys';
import { CACHE_TIME } from '../client';

/**
 * 使用量集計を取得する Query Hook
 */
export function useUsageAggregation(params: UsageAggregationParams) {
  const { getAuthHeader, isLoading: authHeaderLoading, isAuthorized } = useAuthHeader();

  return useQuery({
    queryKey: usageAggregationKeys.data(params.from ?? '', params.to ?? '', params.level),
    queryFn: async () => {
      const authHeaders = getAuthHeader();
      return getUsageAggregationAuthenticated(authHeaders, params);
    },
    enabled: !authHeaderLoading && isAuthorized,
    staleTime: CACHE_TIME.ACCOUNTS_LIST,
  });
}
